export default __webpack_public_path__ + "static/media/screen_google_sheets_00.61574c85.png";